import type React from 'react';
import { createContext, useContext } from 'react';

export const AdditionalHeadersContext: React.Context<Record<string, string>> = createContext<Record<string, string>>(
  {}
);

export const useAdditionalHeaders = (): Record<string, string> => useContext(AdditionalHeadersContext);
